module.exports = __webpack_public_path__ + "img/icon-home-popup-arrow.9f7edf29.svg";